<template>
  <div v-show="isViewActiveLocal" class="text-left mt-2">
    <div ref="whole_page" class="w-full">
      <vx-card id="faqsCard" title="">
        <div class="vx-col w-1/2" style=" display: flex; padding-right: 10px; background-color: transparent !important;">
          <vx-card class="glow-effect_dark card__no-padding bg-color">
            <vx-input-group style="background-color: transparent !important;">
              <template slot="prepend">
                <div class="prepend-text school-primary_gradient">
                  <span
                    ><feather-icon
                      class="pt-1"
                      icon="FilterIcon"
                      svg-classes="stroke-current"
                    ></feather-icon
                  ></span>
                </div>
              </template>

              <v-select
                id="filter-select"
                ref="moduleDropdown"
                class="w-full style-chooser-light style-company-filter"
                placeholder="Filter company(s)..."
                :closeOnSelect="true"
                :options="companyList"
                v-model="currentCompany"
              />
            </vx-input-group>
          </vx-card>
          <vs-button style="margin-left: 34px;" icon-pack="feather" icon="icon-search" icon-after class="school-primary_gradient mr-3" @click="SearchCompany"><span class="hidden sm:block">Search</span></vs-button>
        </div>


        
        <vs-table ref="logbooksTable" class="vs-con-loading__container" single max-items="5" search pagination :data="logbooks">
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th sort-key="studentName">Student</vs-th>
            <vs-th sort-key="moduleName">Linked Module</vs-th>
            <vs-th style="width: 240px;"></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
              <vs-td>
                <img src="https://forty5degreesstorage.blob.core.windows.net/assets/logbook-light.png" width=30px class="product-img" />
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.studentName }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.moduleName ? file.moduleName : "None" }}</p>
              </vs-td>
              <vs-td>
                <div class="flex">
                  <vs-button color="primary" size="small" type="filled" icon-pack="feather" icon="icon-eye" class="mr-3" @click="previewLogbook(file.studentId, file.moduleId)">Preview</vs-button>
                  <vs-button color="success" size="small" type="border" icon-pack="feather" icon="icon-check" @click="showWitnessTestimonyPopup(file)">Accept</vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <b-modal
      id="witness-testimony-popup"
      hide-backdrop
      centered
      ok-only
      scrollable
      no-close-on-backdrop
      content-class="shadow"
      title="Witness Testimony"
      ok-title="Submit"
      @ok="submitWitnessTestimonyAnswers"
      v-model="isPopupActive"
    >
      <div class="vx-row">
        <div class="vx-col w-3/5">
          <h4>Did the Learner:</h4>
        </div>
        <div class="vx-col w-1/5 text-center">
          <h4>Yes</h4>
        </div>
        <div class="vx-col w-1/5 text-center">
          <h4>No</h4>
        </div>
      </div>
      <div class="vx-row mb-1" v-for="(question, index) in witnessTestimonyQuestions" :key="index">
        <div class="vx-col w-3/5 left-col-border">
          <h6>{{index + 1}}. {{ question.text }}</h6>
        </div>
        <div class="vx-col w-1/5 text-center center-col-border">
          <p-radio style="margin-left: 10px;" class="p-round p-fill p-smooth p-bigger" color="success" v-model="question.answer" :value="true" :name="`radio-${index}`"></p-radio>
        </div>
        <div class="vx-col w-1/5 text-center right-col-border">
          <p-radio style="margin-left: 10px;" class="p-round p-fill p-smooth p-bigger" color="success" v-model="question.answer" :value="false" :name="`radio-${index}`"></p-radio>
        </div>
      </div>
      <vs-divider/>
      <div class="vx-row">
        <div class="vx-col w-full">
          <h5>Notes:</h5>
          <vs-textarea id="mentor-note-textarea" class="w-full" v-model="mentorNote" />
        </div>
      </div>
    </b-modal>

    <vs-popup
      id="logbook-preview-popup"
      title="Logbook Preview"
      :active.sync="isLogbookPreviewPopupActive"
      fullscreen
    >
      <div v-if="logbookHtml" class="vx-row">
        <div class="vx-col w-full">
          <div id="html-content" v-html="logbookHtml"></div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { deregisterPlugin } from 'video.js';
import vSelect from "vue-select";
export default {
  props: {
    isViewActive: {
      required: false,
    },
    logbooks: {
      required: false
    },
    showLoading: {
      required: false
    }
  },
  data() {
    return {
      isPopupActive: false,
      witnessTestimonyQuestions: [],
      mentorNote: "",
      studentId:'',
      moduleId:'',
      isLogbookPreviewPopupActive: false,
      logbookHtml: "",
      companyList:[],
      currentCompany: null,
    };
  },
  components: {
    vSelect
  },
  watch: {
    isViewActive: function (val) {
      if(val){
        
      }
    },
    showLoading: function (val) {
      var self = this;
      if (val) {
        self.showLoadingOnElement("logbooksTable", 1, "material");
      }
      else {
        if (self.$refs.logbooksTable) {
          self.$vs.loading.close(self.$refs.logbooksTable.$el);
        }
      }
    },
    isLogbookPreviewPopupActive: function (val) {
      if (!val) {
        this.logbookHtml = "";
      }
    }
  },
  computed: {
    isViewActiveLocal: {
      get() {
        return this.isViewActive;
      }
    },
  },
  methods: {
    SearchCompany(){
      if(this.currentCompany == null){
        this.$emit("getLogbooks", 0);
      }
      else{
        this.$emit("getLogbooks", this.currentCompany.value);
      }
    },
    getMentorCompanys() {
      var self = this;
      var onSuccess = (response) => {
        if (response.data) {
          self.companyList = response.data.map((item) => {
            return { label: item.text, value: item.value };
          });
        }
      };
      self.$ajaxGet(self, "MentorModule/GetCompanysByMentor", onSuccess);
    },

    showWitnessTestimonyPopup(file) {
      var self = this;
      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = (response) => {
        var temp = response.data;
        self.mentorNote = "";
        self.witnessTestimonyQuestions = temp.map(x => {return {
          text: x.text,
          witnessTestimonyQuestionId: x.id,
          studentDocumentId: file.id,
          answer: true
        }});

        self.isPopupActive = true;

        self.moduleId = file.moduleId;
        self.studentId = file.studentId;
      };
      var onFinally = (response) => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self, "WitnessTestimonyQuestion/List?moduleId="+file.moduleId, onSuccess, onFinally);
    },
    submitWitnessTestimonyAnswers() {
      var self = this;
      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = (response) => {
        self.isPopupActive = false;
        self.mentorNote = "";
        self.witnessTestimonyQuestions = [];
        self.$emit("reloadLogbooks", 0);
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Logbook accepted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };
      var onFinally = (response) => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };
      if(!self.mentorNote){
        self.mentorNote = "NA";
      }
      
      self.$ajaxPost(self, `WitnessTestimonyQuestion/SubmitAnswers/${self.mentorNote}/${self.studentId}/${self.moduleId}`, self.witnessTestimonyQuestions, onSuccess, onFinally);
    },
    previewLogbook(studentId, moduleId) {
      const self = this;
      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = function(response) {
        self.isLogbookPreviewPopupActive = true;
        self.logbookHtml = response.data;
      };
      var onFinally = (response) => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };
      self.$ajaxGet(self, `Logbook/GenerateLogbookPreview?userId=${studentId}&moduleId=${moduleId}`, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
  },
  mounted() {
    this.getMentorCompanys();
  },
};
</script>

<style lang="scss">
[id^=witness-testimony-popup] {
  z-index: 42000 !important;
}

#logbook-preview-popup {
  * {
    color: #000000 !important;
  }
  .vs-popup {
    height: fit-content !important;
    background: #ffffff !important;
    color: #000000 !important;

    .vs-popup--content {
      overflow-x: hidden !important;
    }

    .vs-popup--header {
      background: #d8d8d8 !important;

      .vs-popup--close--icon {
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
      }
    }
  }
}

#witness-testimony-popup {
  h1, h2, h3, h4, h5, h6, p, span {
    color: black !important;
  }
  color: black !important;

  .vs-con-textarea {
    background: rgba(255, 255, 255, 1) !important;
  }

  .p-round {
    input {
      width: 21.19px !important;
      height: 21.19px !important;
    }
  }

  
}

.theme-dark {
  #witness-testimony-popup {
    h1, h2, h3, h4, h5, h6, p, span {
      color: rgb(228, 228, 228) !important;
    }
    color: rgb(228, 228, 228) !important;

    .vs-con-textarea {
      background: rgba(255, 255, 255, 1) !important;
    }

    .p-round {
      input {
        width: 21.19px !important;
        height: 21.19px !important;
      }
    }

    
  }
}

#mentor-note-textarea {
  &.vs-textarea {
    color: black !important;
  }
}


.style-company-filter {

  .selected-tag {
    background: transparent !important;
  }
}

  // #filter-select input {
  //   color: #3d3d3d !important;
  // }
</style>
